import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-set-prestamo',
  templateUrl: './set-prestamo.component.html',
  styleUrls: ['./set-prestamo.component.css']
})
export class SetPrestamoComponent implements OnInit {

  public unidades: number = 0;

  constructor(public activeModal: NgbActiveModal) {}
   ngOnInit(): void {
       
   }
  // cerrar devolviendo el valor
  guardar() {
    const val = Number(this.unidades) || 0;
    // opcional: no permitir 0 o negativo
    // if (val <= 0) return;
    this.activeModal.close(val);
  }

  cancelar() {
    this.activeModal.dismiss(null);
  }

}
